// Module
var code = "<div class=\"form-group\"> <label>{{'Subject'|translate}}</label> <input ng-model=\"vm.subject\" class=\"form-control input-sm\" placeholder=\"{{'Enter a subject'|translate}}\" ng-required=\"true\" name=\"title\" ondrop=\"return!1\" type=\"text\"/> </div>";
// Exports
module.exports = code;